import React from "react";

const Contact = () => {
	return (
		<div className="max-w-2xl mx-auto p-6 text-gray-800">
			<h1 className="text-2xl font-bold mb-4">Contact Us</h1>
			<p className="mb-4">
				Have questions or need assistance? Reach out to us, and we’ll get back to you as soon as possible.
			</p>

			<div className="bg-gray-500 dark:bg-gray-700 p-6 rounded-lg shadow-md">
				<h2 className="text-lg font-semibold text-gray-900 dark:text-gray-200">Email</h2>
				<p className="text-blue-800">
					<a href="mailto:info@materiallogs.com" className="hover:underline text-gray-100">
						info@materiallogs.com
					</a>
				</p>
			</div>
		</div>
	);
};

export default Contact;